{
  const drawer = document.getElementById('mobile-drawer');
  const backdrop = document.getElementById('drawer-backdrop');

  if (drawer && backdrop) {
  const openDrawer = () => {
    drawer.classList.add('is-open');
    backdrop.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  };

  const closeDrawer = () => {
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-visible');
    document.body.style.overflow = '';
  };

  document.querySelectorAll('.js-drawer-open').forEach((btn) => {
    btn.addEventListener('click', openDrawer);
  });

  document.querySelectorAll('.js-drawer-close').forEach((btn) => {
    btn.addEventListener('click', closeDrawer);
  });

  document.querySelectorAll('.drawer__nav-group-toggle').forEach((btn) => {
    btn.addEventListener('click', function () {
      const group = this.closest('.drawer__nav-group');
      const isOpen = group.classList.contains('is-open');
      group.classList.toggle('is-open', !isOpen);
      this.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  document.querySelectorAll('.drawer__nav-subgroup-toggle').forEach((btn) => {
    btn.addEventListener('click', function () {
      const subgroup = this.closest('.drawer__nav-subgroup');
      const isOpen = subgroup.classList.contains('is-open');
      subgroup.classList.toggle('is-open', !isOpen);
      this.setAttribute('aria-expanded', String(!isOpen));
    });
  });
  }
}
